// UI
import ScrollableScreen from '@/components/ui/ScrollableScreen'
import WarrantyDisplay from '@/components/warranties/WarrantyDisplay'

// Mantine
import { Menu, ActionIcon } from '@mantine/core'
import { modals } from '@mantine/modals'
import { notifications } from '@mantine/notifications'

// Icons
import { IconDotsVertical, IconExternalLink, IconTrash, IconQrcode } from '@tabler/icons-react'

// QR
import QRCode from 'react-qr-code'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Next
import { useParams, useNavigate } from 'react-router-dom'
import RouterLink from '@/components/ui/RouterLink'

export default function WarrantyDisplayPage() {
    const navigate = useNavigate()
    const { requestDelete } = useAxiosApi()
    const { code } = useParams()

    const url = 'https://baltic-watches.com/w/' + code

    const handleDeleteWarranty = async () => {
        await requestDelete(`/warranties/${code}`)

        navigate('/warranties')

        notifications.show({
            title: code,
            message: 'La garantie a été supprimée.',
            color: 'red',
        })
    }

    const deleteWarranty = () =>
        modals.openConfirmModal({
            title: 'Supprimer la garantie',
            children: 'Cette action est irréversible.',
            labels: { confirm: 'Supprimer', cancel: 'Annuler' },
            confirmProps: { color: 'red' },
            onConfirm: handleDeleteWarranty,
        })

    const showQRCode = () =>
        modals.open({
            title: 'QR Code',
            children: (
                <div className="flex flex-col items-center gap-4 py-4">
                    <QRCode size={200} value={url} />
                    <span className="text-sm text-gray-500">{url}</span>
                </div>
            ),
        })

    const breadcrumbs = [
        { label: 'Garanties', href: '/warranties' },
        { label: code },
    ]

    const rightSection = (
        <Menu shadow="md" width={180} position="bottom-end">
            <Menu.Target>
                <ActionIcon variant="default" size={36}>
                    <IconDotsVertical size={15} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item
                    component={RouterLink}
                    href={url}
                    target="_blank"
                    leftSection={<IconExternalLink size={14} />}
                >
                    Page client
                </Menu.Item>
                <Menu.Item
                    onClick={showQRCode}
                    leftSection={<IconQrcode size={14} />}
                >
                    QR Code
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item
                    color="red"
                    onClick={deleteWarranty}
                    leftSection={<IconTrash size={14} />}
                >
                    Supprimer
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs} rightSection={rightSection}>
            <div className="p-5">
                <div className="w-full max-w-[600px] mx-auto bg-white p-8 border rounded-sm">
                    <WarrantyDisplay key={code} code={code} />
                </div>
            </div>
        </ScrollableScreen>
    )
}
